import Mixin from '../Mixin';
import FDictionaryTransfer from '@/modules/Dictionary/Transfer/Select';
import FDictionaryTransport from '@/modules/Dictionary/Transport/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  transfer = new FDictionaryTransfer({
    label: 'Трансфер',
    required: true,
  });

  transport = new FDictionaryTransport({
    label: 'Транспорт',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['transfer', this.transfer],
      ['transport', this.transport],
    ]);
    this.transfer.city = this.city;
    this.service.set({
      value: 2,
      label: 'Трансфер',
    });
  }


  set(value = {}) {
    super.set(value);
    this.__set('transfer', value.transfer, null);
    this.__set('transport', value.transport, null);
    return this;
  }

  toString() {
    return this.transfer.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.transfer.toLabel();
        return data;
      });
  }
}
